import * as campaignTypes from './campaign.type';

import { API } from '../../../services/http.service';

const REQUEST_URL = '';

/**
 * Aktif kampanya döneminin kampanyalarını getirir. Backend yalnızca Satış
 * Temsilcisi (USER) rolüne içerik döner; diğer roller boş liste alır.
 */
export const getUserCampaignList = () => async (dispatch) => {
  dispatch({ type: campaignTypes.GET_CAMPAIGN_LIST_PENDING });

  try {
    const response = await API.get(`${REQUEST_URL}/competition/userCampaignList`);
    dispatch({
      type: campaignTypes.GET_CAMPAIGN_LIST_FULFILLED,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: campaignTypes.GET_CAMPAIGN_LIST_REJECTED,
      payload: error,
    });
    return Promise.reject(error);
  }
};
